import { render, staticRenderFns } from "./InfoPoint.vue?vue&type=template&id=39108008"
import script from "./InfoPoint.vue?vue&type=script&lang=js"
export * from "./InfoPoint.vue?vue&type=script&lang=js"
import style0 from "./InfoPoint.vue?vue&type=style&index=0&id=39108008&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports